export default __webpack_public_path__ + "static/media/glossary-card-icon.ec6740f9.svg";